export var ColumnRole;
(function (ColumnRole) {
    ColumnRole["COLUMN_ROLE_UNSPECIFIED"] = "COLUMN_ROLE_UNSPECIFIED";
    ColumnRole["COLUMN_ROLE_PRIMARY_KEY"] = "COLUMN_ROLE_PRIMARY_KEY";
    ColumnRole["COLUMN_ROLE_SESSION_KEY"] = "COLUMN_ROLE_SESSION_KEY";
    ColumnRole["COLUMN_ROLE_EVENT_TIME"] = "COLUMN_ROLE_EVENT_TIME";
    ColumnRole["COLUMN_ROLE_INGEST_TIME"] = "COLUMN_ROLE_INGEST_TIME";
    ColumnRole["COLUMN_ROLE_JOIN_KEY"] = "COLUMN_ROLE_JOIN_KEY";
    ColumnRole["COLUMN_ROLE_MODEL_FEATURE"] = "COLUMN_ROLE_MODEL_FEATURE";
    ColumnRole["COLUMN_ROLE_PARTITION_KEY"] = "COLUMN_ROLE_PARTITION_KEY";
})(ColumnRole || (ColumnRole = {}));
